import { Templates } from '../../compile';
import { NotificationOptions } from '../../interfaces/options';
import { NotificationType } from '../../enums';

export const DefaultNotificationOptions: NotificationOptions = {
	template: Templates.notification_default,
	type: NotificationType.Hint,
	visible: true
};
